import React from 'react'
import styled from 'styled-components'

import { Box } from '@usap/uicomponents'

export const Container = styled(Box)`
  border: solid 1px transparent;
  width: 100%;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    border: solid 1px #E0E0E0;
  }
`

export const SubHeading = styled(Box)`
  flex-direction: row;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    flex-direction: column;
  }
`

export const LiveChat = styled.button`
  color: #05629B;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font-size: 12px;
  font-weight: bold;
`

export const Spacer = styled(Box)`
  width: 100%;
  align-items: center;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    alignn-items: flex-end;
    width: 50%;
  }
`
